import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { AGENT_ICONS } from "../../../../components/AgentNode/AgentNode";
import "../../../../components/AgentNode/AgentNode.css";

export default function DraggableAgentNode({ agent }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: agent.id,
      data: agent,
    });

  const color = agent.style?.color || "#B07AA1";
  const icon = agent.icon || "bot";
  const left = `${agent.position?.x ?? 50}%`;
  const top = `${agent.position?.y ?? 50}%`;

  const wrapperStyle = {
    position: "absolute",
    left,
    top,
    zIndex: isDragging ? 50 : 20,
    transform: [
      "translate(-50%, -100%)",
      transform ? `translate(${transform.x}px, ${transform.y}px)` : "",
    ]
      .filter(Boolean)
      .join(" "),
    transformOrigin: "bottom center",
    pointerEvents: "auto",
    cursor: isDragging ? "grabbing" : "grab",
  };

  return (
    <div ref={setNodeRef} style={wrapperStyle} {...listeners} {...attributes}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", "--agent-color": color }}>
        <div
          className="agent-node-pill"
          style={{ cursor: "inherit" }}
        >
          <svg
            className="agent-node-pill-icon"
            viewBox={AGENT_ICONS[icon]?.viewBox || AGENT_ICONS.bot.viewBox}
            fill={AGENT_ICONS[icon]?.stroke ? "none" : "currentColor"}
            stroke={AGENT_ICONS[icon]?.stroke ? "currentColor" : undefined}
            strokeLinecap={AGENT_ICONS[icon]?.stroke ? "round" : undefined}
            strokeLinejoin={AGENT_ICONS[icon]?.stroke ? "round" : undefined}
          >
            <path d={AGENT_ICONS[icon]?.path || AGENT_ICONS.bot.path} />
          </svg>
          <span className="agent-node-pill-name"><span className="agent-node-pill-prefix">Agent:</span> {agent.name || "Agent"}</span>
          <span className="agent-node-pill-dot" />
        </div>
        <div className="agent-node-stem" />
        <div className="agent-node-ring" />
      </div>
    </div>
  );
}
